<template>
  <BarChart :chartData="chartDatasets" :options="chartOptions" :height="chartHeight" :width="chartWidth" />
</template>
<script>
import { BarChart } from 'vue-chart-3';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'

Chart.register(...registerables, ChartDataLabels);

export default {
  name: 'ProjectFinanceMetricsChart',
  components: { BarChart },
  props: {
    dataSet: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  data() {
    return {
      chartDatasets: {
        labels: [],
        datasets: [{
          footer: '123123',
          label: 'Data1',
          data: [],
          quantity_dynamics: [],
          stack: 'Stack 0',
          backgroundColor: '#9ac2ff',
          // borderWidth: {
          //     top: 4
          // },
          // BarThickness: 52,
          barPercentage: 0.8,
          // categoryPercentage: 0.1,
          // maxBarThickness: 52,
          borderColor: 'transparent',
          borderRadius: {
            topLeft: 2,
            topRight: 2,
          },
          borderSkipped: false,
          datalabels: {

            color: 'transparent',
            labels: {
              value: {
                // color: 'white'
              }
            }
          }
        },
          {
            footer: '123123',
            label: 'Data1',
            data: [],
            quantity_dynamics: [],
            stack: 'Stack 1',
            backgroundColor: '#c3b5e1',
            // borderWidth: {
            //     top: 4
            // },
            // BarThickness: 52,
            barPercentage: 0.8,
            // categoryPercentage: 0.1,
            // maxBarThickness: 52,
            borderColor: 'transparent',
            borderRadius: {
              topLeft: 2,
              topRight: 2,
            },
            borderSkipped: false,
            datalabels: {

              color: 'transparent',
              labels: {
                value: {
                  // color: 'white'
                }
              }
            }
          }]
      },
      chartOptions: {
        animations: false,
        onHover: (event, chartElement) => {
          event.native.target.style.cursor = 'pointer'
        },
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: false,
          datalabels: {
            labels: {
              value: {
                anchor: 'center',
                align: 'center',
                formatter: (value, context) => {
                  //console.log(context.dataset.topics[context.dataIndex].quantity_percent)
                  // if (context.dataset.topics[context.dataIndex].quantity_percent > 10) {
                  //     return context.dataset.topics[context.dataIndex].quantity_percent + '%'
                  // }
                  // return ''
                }
              },
              title: {
                formatter: (value, context) => {
                  // if (context.datasetIndex === context.chart.data.datasets.length - 1) {
                  //     //console.log(context.dataIndex)
                  //     return [Object.values(context.chart.data.datasets[2].countMax)[context.dataIndex].sum_quantity, '', '']
                  // }
                   return String(value).split('.').join(',')
                },
                anchor: 'end',
                color: '#252628',
                align: 'end',
                font: {
                  size: document.documentElement.clientWidth >= 768 ? 16 : 14,
                  family: 'Gilroy-SemiBold'
                }
              }
            }
          },
        },
        responsive: () => {
          return this.isMobile();
        },
        scales: {
          x: {
            grid: {
              display: false,
              borderColor: '#999999',
            },
            ticks: {
              color: '#999999',
              font: {
                size: 12
              },
              padding: 2,
              callback: (idx) => {
                if (this.chartDatasets.labels[idx].includes(' ')) {
                  let splitArr = this.chartDatasets.labels[idx].split(' ');
                  let number = [splitArr[0] + ' ' + splitArr[1], splitArr[2]];
                  return number;
                } else return this.chartDatasets.labels[idx]
              }
            },
          },
          y: {
            grid: {
              drawBorder: true,
              drawTicks: true,
              display: false,
              borderColor: '#999999'
            },
            title: {
              display: false
            },
            max: Math.max.apply(null, this.dataSet.map((a) => parseInt(a.escrow))) * 1.5,
            ticks: {
              color: '#999999',
              // backdropPadding: 10,
              font: {
                size: 12
              },
              align: 'end',
              callback(val, index, ticks) {
                //console.log(ticks)
                const maxCount = Math.max.apply(null, ticks.map((a) => a.value))
                if (val === maxCount) {
                  return document.documentElement.clientWidth >= 767 ? ['трлн', '₽', ' '] : ['трлн', '₽', ' ']
                } else {
                  return val
                }
              },
            }
          }
        }
      }
    };
  },
  mounted() {
    let periods;
    if (document.documentElement.clientWidth <= 649) {
      periods = this.dataSet.slice(2);
    } else {
      periods = this.dataSet;
    }
    periods.forEach((el, idx) => {
      //console.log(el)
      this.chartDatasets.labels[idx] = el.quarter;
      this.chartDatasets.datasets[0].data[idx] = parseFloat(el.escrow.split(',').join('.'));
      this.chartDatasets.datasets[1].data[idx] = parseFloat(el.debt.split(',').join('.'));
    })
    //console.log(this.chartDatasets)
  },
  computed: {
    isDesktop() {
      return document.documentElement.clientWidth >= 1124;
    },
    chartHeight() {
      return (this.isDesktop) ? 586 : 586;
    },
    chartWidth() {
      return (this.isDesktop) ? 485 : 520;
    }
  },
  methods: {
    formatNum(num) {
      if (Number(num) > 0) {
        return '+' + num;
      } else {
        return num;
      }
    },
    isMobile() {
      return document.documentElement.clientWidth <= 650;
    },
    getColor(val) {
      return 'color:#6D6D6D;';
    }
  },
}
</script>